import { getEpgVersionFromService } from '../requests/loader';
import ChannelSingleton from '../components/Epg/ChannelsSingleton';
import DeviceStorage from '../components/DeviceStorage/DeviceStorage';
import Utils from './Utils';
import Device from '../devices/device';
import Badges from '../requests/apa/Badges';
import Launcher from '../requests/apa/Launcher';
import Metadata from '../requests/apa/Metadata';
import * as loader from '../requests/loader';
import Asset from '../requests/apa/Asset';
import AAFPlayer from '../AAFPlayer/AAFPlayer';
import { AAFPLAYER_PLAY } from '../AAFPlayer/constants';
import store from '../store';
import { playFullMedia } from '../actions/playmedia';
import TvChannelUtil from './TvChannelUtil';
import { showModal, MODAL_GENERIC, MODAL_ACTUALIZATION_EPGVERSION } from '../actions/modal';
import Translator from '../requests/apa/Translator';
import EpgFeederManager from '../AAFPersistenceManager/feeders/EpgFeederManager';
import EpgPersistence from '../AAF/Nepg/EpgPersistence';
import DashboardTracker from '../utils/trackers/DashboardTracker';
import { isAndroidDevice } from '../AAFPersistenceManager/helpers/Utils';
import getAppConfig from '../config/appConfig';
import AAF from '../AAF/AAF';
import { EPG_VERSION_TTL, LINEAL_CHANNELS_TTL } from 'src/AAF/Resilence/TTLConstants';
import { MODAL_PIN_CODE_CHANNEL_TYPE } from 'src/components/Modal/ModalPinCode';
const TTLItemEV = EPG_VERSION_TTL;
const TTLItemLC = LINEAL_CHANNELS_TTL;

class EpgVersionStatus {
  constructor(updateApp) {
    this.__updateApp = updateApp;
    this.__checkerID = null;
    this.__checkerIDLinealChannels = null;
    this.__checkerInterval = parseInt(Utils.getIntervalTimeCheckEpgVersion());
    this.__checkerIntervalLinealChannels = parseInt(Utils.getIntervalTimeCheckLinealChannels());
    this.tmp = null;
    this.__checkerID_postpone = parseInt(Utils.getIntervalTimeCheckPostpone()) * 60000;
    this._checkedTimeout = null;
    this._banderaModalActualizacion = true;
    this.enabledOmitir = this.enabledOmitir.bind();
    this.showModal = this.showModal.bind(this);
    this.sendMetric = this.sendMetric.bind(this);

    console.log('[EpgVersionStatus] init');
  }

  setEpgVersion = version => {
    console.log('[EpgVersionStatus] setEpgVersion version', version);
    if (version) {
      DeviceStorage.setItem('epgVersion', version);
    }
  };

  setAppVersionApi = version => {
    console.log('[EpgVersionStatus] setAppVersionApi version', version);
    if (version) {
      DeviceStorage.setItem('appVersionApi', version);
    }
  };

  clearHKS = () => {
    DeviceStorage.setItem('HKS', '');
    localStorage.setItem('refresh', 'true');
  };

  setSoaVersion = version => {
    console.log('[EpgVersionStatus] setSoaVersion version', version);
    if (version) {
      DeviceStorage.setItem('soaVersion', version);
    }
  };

  setAppVersionLastUpdated = version => {
    console.log('[EpgVersionStatus] setAppVersionLastUpdated version', version);
    if (version) {
      DeviceStorage.setItem('appVersionLastUpdated', version);
    }
  };

  getAppVersionLastUpdated = () => {
    console.log('[EpgVersionStatus] getAppVersionLastUpdated');
    return DeviceStorage.getItem('appVersionLastUpdated') || null;
  };

  getEpgVersion = () => {
    console.log('[EpgVersionStatus] getEpgVersion');
    return DeviceStorage.getItem('epgVersion') || null;
  };

  getSoaVersion = () => {
    console.log('[EpgVersionStatus] getSoaVersion');
    return DeviceStorage.getItem('soaVersion') || null;
  };

  getAppVersion = () => {
    console.log('[EpgVersionStatus] getAppVersion');
    return DeviceStorage.getItem('appVersion') || null;
  };

  resetEpg = () => {
    console.log('[EpgVersionStatus] resetEpg');
    const cb = this.getCheckPlayingPermissionAsCb();
    new ChannelSingleton().resetData(cb).then(() => {
      if (this.__updateApp.length !== 0 && typeof this.__updateApp[0] === 'function') {
        console.log('[EpgVersionStatus] resetEpg __updateApp');
        this.__updateApp[0]();
        if (EpgPersistence.isDatabaseDataSource()) {
          new EpgFeederManager().inserting();
        }
      }
    });
  };

  getLastChannel = () => {
    return TvChannelUtil.getLastChannel() || null; 
  }

  getCheckPlayingPermissionAsCb = () => {
    return () => {
      setTimeout(this.checkPlayingPermission, 3000);
    };
  }

  checkPlayingPermission = () => {
    console.log('[EpgVersionStatus] checkPlayingPermission');
    if (this.isPlayingLive()) {
      console.log('[EpgVersionStatus] checkPlayingPermission isPlayingLive');
      const groupId = this.getStateGroupId();
      console.log('[EpgVersionStatus] checkPlayingPermission groupId', groupId);
      if (
        Utils.isNotNullOrNotUndefined(groupId) &&
        !ChannelSingleton.canPlayChannel(groupId)
      ) {
        console.log(
          '[EpgVersionStatus] checkPlayingPermission can not Play Channel, play first channel',
          this.getFirstGroupId()
        );
        this.playChannel(this.getFirstGroupId());
      }
    } else {
      const lastChannel = this.getLastChannel();
      console.log('[EpgVersionStatus] checkPlayingPermission lastChannel', lastChannel);
      if (
        Utils.isNotNullOrNotUndefined(lastChannel) &&
        !ChannelSingleton.canPlayChannel(lastChannel)
      ) {
        console.log(
          '[EpgVersionStatus] checkPlayingPermission can not Play Channel, set Last Channel in storage',
          this.getFirstGroupId()
        );
        TvChannelUtil.setLastChannel(this.getFirstGroupId());
      }
    }
  };

  isPlayingLive = () => {
    console.log('[EpgVersionStatus] isPlayingLive function');
    const cstate = AAFPlayer.getCurrentPlayerOptions(false);
    if (!cstate) return false;
    const { playerstate, islive } = cstate;
    return playerstate === AAFPLAYER_PLAY && islive ? true : false;
  };

  playChannel = groupId => {
    console.log('[EpgVersionStatus] playChannel groupId', groupId);
    if (Utils.isNotNullOrNotUndefined(groupId)) {
      store.dispatch(
        playFullMedia({
          playerstate: AAFPLAYER_PLAY,
          source: {
            videoid: groupId
          },
          size: {
            top: 0,
            left: 0,
            width: 1280,
            height: 720
          },
          ispreview: false,
          islive: true,
          ispip: false,
          event: null
        })
      );
    }
  };

  getStateGroupId = () => {
    const cstate = AAFPlayer.getCurrentPlayerOptions(false);
    console.log('[EpgVersionStatus] cstate', cstate);
    if (cstate) {
      const { source } = cstate;
      if (source) {
        const { videoid } = source;
        if (videoid) {
          return videoid;
        }
      }
    }
    return null;
  };

  getFirstGroupId = () => {
    AAF.TTLUtil.verifyTTLItem(TTLItemLC, () => { AAF.TTLUtil.setLinealChannels() }, 'EpgVersionStatus[getFirstGroupId]');
    const linealChannels = store.getState().linealChannels;
    let nextGroupId = null;
    if (Array.isArray(linealChannels) && linealChannels[0]) {
      nextGroupId = linealChannels[0].id;
    }
    return nextGroupId;
  };

  loadApisAgain = async () => {
    try{
      const [apaLauncher, apaMetadata, apaAsset] = await Promise.all([
        loader.apaLauncher(),
        loader.apaMetadataMiddleware(),
        loader.apaAsset()
      ]);
      const {badges, ...newApaMetadata} = apaMetadata;
      Metadata.setData(newApaMetadata);
      Asset.setData(apaAsset);
      Badges.set(badges);
      if (apaLauncher) {
        if (!Utils.isAkamaiMfwkinLauncher(apaLauncher.response)) {
          try {
            const tracker = new DashboardTracker();
            if (apaLauncher && apaLauncher.code) {
              tracker.trackEpg('akamai_mfwk not exists', 1, {
                msg: `Cannot find Akamai_mfwk in Launcher`,
                stackTrace: '/services/apa/launcher'
              });
            }
            const device = Device.getDevice().getConfig();
            if (device && typeof device == 'object' && device.hasOwnProperty('akamai_mfwk')) {
              if (apaLauncher.response && typeof apaLauncher.response == 'object') {
                // Si no existe el valor de akamai_mfwk en Launcher, se pone el valor de Config por device.
                apaLauncher.response.akamai_mfwk = device.akamai_mfwk;
              }
            }
          } catch (error) {
            console.log('[EpgVersionStatus] loadApisAgain catch 2 e',e);
          }
        }
        const region = DeviceStorage.getItem('region');
        Device.getDevice().update_launcher(region, apaLauncher.response);
        Launcher.setData(apaLauncher.response);
      }
      console.log('[EpgVersionStatus] loadApisAgain sigue vivo 6');
    }
    catch(e){
      console.log('EpgVersionStatus loadApisAgain catch e',e);
    }
    return new Promise(resolve => {
      resolve();
    });
  };

  isSTB = () => {
    return isAndroidDevice();
  }

  resetApp = (sessionRefresh = false) => {
    console.log('[EpgVersionStatus] resetApp');
    if (this.isSTB()) {
      const {end_point_middleware = '',device_id = '' } = getAppConfig() || {};
      if (sessionRefresh) {
        this.clearHKS();
      }
      console.log('Stop stb player');
      window.AndroidPlayerInterface.stopFullPlayer();
      console.log('Va a reiniciar');
      fetch(`${end_point_middleware}successful-reset?device_id=${device_id}`);
      window.location.replace('/');
    }
  };

  sendMetric = (selection = "") => {
    const { user: {user_id = "", isAnonymous = "", region = "", parent_id = ""} } = store.getState();
    const dataMetric = {
      event: 'update',
      selection,
      user_id,
      user_type: isAnonymous ? "anonimo" : "registrado",
      country: region.trimStart().trimEnd().replace(' ','_'),
      parent_id
    }
    window.dataLayer.push(dataMetric)
}

  msToTime(duration) {
    try {
      let hours = parseInt((duration / (1000 * 60 * 60)) % 24);

      return hours
    } catch (error) {
      return "";
    }
  }

  showModal = responseEpgVersion => {
    const refresh = responseEpgVersion.session_refresh;
    const keyTextDescription = responseEpgVersion.soa_message;
    const timeText = this.msToTime(this.__checkerID_postpone);
    let textPosponer = Translator.get('soa_apa_postpone_option_button_delay', "POSPONER @time HR");
    textPosponer = (textPosponer != null && textPosponer !== '' && textPosponer !== undefined) ? textPosponer.replace('@time', timeText) : '';
    let modalTitle = Translator.get('soa_apa_postpone_title_label',"")
    const textContent = Translator.get(`${keyTextDescription}`,'Presiona aceptar para tener una mejor experiencia.',)
    let iconTitle = ""

    if(modalTitle === ""){
      modalTitle = Translator.get('soa_apa_postpone_warning_title_label',"")
    }

    if(Asset.get('soa_apa_icon') !== ""){
      iconTitle = Asset.get('soa_apa_icon')
    }else {
      iconTitle = Asset.get('alert_warning_generic_icon')
    }
    
    const state = store.getState();
    const fromModalPinChannel = state.modal && state.modal.modalType === "PIN" && state.modal.modalProps && state.modal.modalProps.type === MODAL_PIN_CODE_CHANNEL_TYPE;
    
    store.dispatch(
      showModal({
        modalType: MODAL_ACTUALIZATION_EPGVERSION,
        modalProps: {
          className: 'modal_actualization_epg_version',
          from: 'epgVersionStatus',
          aafNewStyle: true,
          buttons: [
            {
              content: Translator.get('soa_apa_postpone_option_button_close', 'ACEPTAR'),
              props: {
                onClick: () => {
                  this.sendMetric('aceptar');
                  this.resetApp(refresh);
                },
                className: 'button_act_epg_version',
              }
            },
            {
              content: textPosponer,
              props: {
                onClick: () => {
                  this.enabledOmitir();
                  if(fromModalPinChannel) {
                    const previousChannel = {
                      playerstate: 'PLAYING',
                      source: {
                        videoid: DeviceStorage.getItem("previousChannel")
                      },
                      size: {
                        top: 0,
                        left: 0,
                        width: 1280,
                        height: 720,
                      },
                      ispreview: false,
                      islive: true,
                      ispip: false,
                      event: null,
                    };        
                    store.dispatch(playFullMedia(previousChannel));
                  }
                },
                className: 'button_act_epg_version',
                variant: 'default',
              }
            }
          ],
          title: modalTitle !== "" ? modalTitle : false,
          asset: iconTitle,
          content: textContent,
          callbackWhenBack: () => {
            this.enabledOmitir();
            if(fromModalPinChannel) {
              const previousChannel = {
                playerstate: 'PLAYING',
                source: {
                  videoid: DeviceStorage.getItem("previousChannel")
                },
                size: {
                  top: 0,
                  left: 0,
                  width: 1280,
                  height: 720,
                },
                ispreview: false,
                islive: true,
                ispip: false,
                event: null,
              };        
              store.dispatch(playFullMedia(previousChannel));
            }
          }
        }
      })
    );
  };

  enabledOmitir = () => {
    this.sendMetric('posponer')
    clearTimeout(this._checkedTimeout);
    this._banderaModalActualizacion = false;
    this._checkedTimeout = setTimeout(() => {
      this.showModal(this.tmp);
    }, this.__checkerID_postpone);
  };

  checkVersion = async (fromTTL = false) => {
    this._banderaModalActualizacion = true;
    const epgVersionFromLocalStorage = this.getEpgVersion();
    let soaVersionFromLocalStorage = this.getSoaVersion();
    const appVersionFromLocalStorage = this.getAppVersion();
    const epgVersionFromService = await getEpgVersionFromService();
    const appVersionLastUpdated = this.getAppVersionLastUpdated();

    if (Utils.isNullOrUndefined(soaVersionFromLocalStorage)) {
      soaVersionFromLocalStorage = '0.0.0';
    }
    console.log(
      '[EpgVersionStatus] checkVersion epgVersionFromLocalStorage:',
      epgVersionFromLocalStorage,
      ', appVersionFromLocalStorage: ',
      appVersionFromLocalStorage,
      ', soaVersionFromLocalStorage: ',
      soaVersionFromLocalStorage,
      ', epgVersionFromService:',
      epgVersionFromService
    );
    if (
      Utils.isNotNullOrNotUndefined(epgVersionFromService) &&
      Utils.isNotNullOrNotUndefined(epgVersionFromService.app_version)
    ) {
      const appVersionFromService = epgVersionFromService.app_version;
      const soaVersionFromService = epgVersionFromService.soa_version;
      const sessionRefresh = epgVersionFromService.session_refresh;

      if (!fromTTL) {
        AAF.TTLUtil.setStorageItemTTL(TTLItemEV);
      }

      console.log(
        '[EpgVersionStatus] checkVersion appVersionFromService',
        appVersionFromService
      );
      
      this.setAppVersionApi(appVersionFromService);
      if (Utils.isNotNullOrNotUndefined(appVersionLastUpdated)) {
        if (Utils.compareVersions(appVersionFromService, appVersionLastUpdated)) {
          this.setAppVersionLastUpdated(appVersionFromService);
          this.resetApp(sessionRefresh);
        } else if (
          Utils.compareVersions(soaVersionFromService, soaVersionFromLocalStorage)
        ) {
          console.log(
            '[EpgVersionStatus]',
            soaVersionFromService,
            'es mayor que ',
            soaVersionFromLocalStorage
          );
          if(this._banderaModalActualizacion){
            // this.setSoaVersion(soaVersionFromService);
            this.showModal(epgVersionFromService);
          }
          this.tmp = epgVersionFromService;
        }
      } else if (Utils.isNotNullOrNotUndefined(appVersionFromLocalStorage)) {
        if (Utils.compareVersions(appVersionFromService, appVersionFromLocalStorage)) {
          this.setAppVersionLastUpdated(appVersionFromService);
          this.resetApp(sessionRefresh);
        } else if (
          Utils.compareVersions(soaVersionFromService, soaVersionFromLocalStorage)
        ) {
          console.log(
            '[EpgVersionStatus]',
            soaVersionFromService,
            'es mayor que ',
            soaVersionFromLocalStorage
          );
          if(this._banderaModalActualizacion){
            // this.setSoaVersion(soaVersionFromService);
            this.showModal(epgVersionFromService);
          }
          this.tmp = epgVersionFromService;
        }
      }
    }
    if (
      epgVersionFromLocalStorage &&
      epgVersionFromService &&
      epgVersionFromService.epg_version
    ) {
      console.log(
        '[EpgVersionStatus] epgVersion comparison ',
        epgVersionFromLocalStorage,
        ' vs ',
        epgVersionFromService.epg_version
      );

      if (epgVersionFromLocalStorage != epgVersionFromService.epg_version) {
        this.setEpgVersion(epgVersionFromService.epg_version);
        this.loadApisAgain().then(() => {
          console.log('[EpgVersionStatus] resetEpg');
          this.resetEpg();
        });
      }
    }
  };

  checkLinealChannels = () => {
    console.log('[EpgVersionStatus] checkLinealChannels');
    const cb = this.getCheckPlayingPermissionAsCb();
    new ChannelSingleton().checkLinealChannels(cb);
  };

  startCheckVersion = async cb => {
    const epgVersionResponse = await getEpgVersionFromService();
    AAF.TTLUtil.setStorageItemTTL(TTLItemEV);
    if (cb && typeof cb === 'function') cb();
    console.log('[EpgVersionStatus] startCheckVersion epgVersionResponse', epgVersionResponse);
    if (epgVersionResponse && epgVersionResponse.epg_version) {
      this.setEpgVersion(epgVersionResponse.epg_version);
    }
    if (epgVersionResponse && epgVersionResponse.soa_version) {
      this.setSoaVersion(epgVersionResponse.soa_version);
    }
    if (epgVersionResponse && epgVersionResponse.app_version) {
      this.setAppVersionApi(epgVersionResponse.app_version);
    }
   
    if(this.isSTB()){
      this.__checkerID = setInterval(this.checkVersion, this.__checkerInterval * 60000);
    }
    window.youboraParams[14].value = DeviceStorage.getItem('epgVersion') || '';
  };

  startCheckLinealChannels = () => {
    this.__checkerIDLinealChannels = setInterval(
      this.checkLinealChannels,
      this.__checkerIntervalLinealChannels * 60000
    );
  };
}

export default EpgVersionStatus;



// WEBPACK FOOTER //
// ./src/utils/EpgVersionStatus.js